import React from 'react';
import avatar from '../../assests/logo.png';
import { IoMdAddCircle } from 'react-icons/io';

const ChatTopbar = ({ selectedTeacher }) => {
  return (
    <div className="chat-header">
      {selectedTeacher === '' ? (
        <p className="chat-header-icon">
          <IoMdAddCircle />
        </p>
      ) : (
        <img src={selectedTeacher.imageId || avatar} alt="avatar" className="chat-header-avatar" />
      )}
      <div className="chat-header-info">
        <h2 className="chat-header-username mb-0">
          {selectedTeacher.first_name} {selectedTeacher.middle_name} {selectedTeacher.last_name}
        </h2>
      </div>
    </div>
  );
};

export default ChatTopbar;
